/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Cost_TelemetryInputs */

const en_svchip_cost_telemetry = /** @type {(inputs: Svchip_Cost_TelemetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost telemetry`)
};

const ar_svchip_cost_telemetry = /** @type {(inputs: Svchip_Cost_TelemetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قياس التكلفة`)
};

const bn_svchip_cost_telemetry = /** @type {(inputs: Svchip_Cost_TelemetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কস্ট টেলিমেট্রি`)
};

const de_svchip_cost_telemetry = /** @type {(inputs: Svchip_Cost_TelemetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostentelemetrie`)
};

const es_svchip_cost_telemetry = /** @type {(inputs: Svchip_Cost_TelemetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telemetría de costos`)
};

const fr_svchip_cost_telemetry = /** @type {(inputs: Svchip_Cost_TelemetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télémétrie des coûts`)
};

const pt_svchip_cost_telemetry = /** @type {(inputs: Svchip_Cost_TelemetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telemetria de custos`)
};

const zh_svchip_cost_telemetry = /** @type {(inputs: Svchip_Cost_TelemetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成本遥测`)
};

const tr_svchip_cost_telemetry = /** @type {(inputs: Svchip_Cost_TelemetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maliyet telemetrisi`)
};

const ru_svchip_cost_telemetry = /** @type {(inputs: Svchip_Cost_TelemetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Телеметрия затрат`)
};

const pl_svchip_cost_telemetry = /** @type {(inputs: Svchip_Cost_TelemetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telemetria kosztów`)
};

/**
* | output |
* | --- |
* | "Cost telemetry" |
*
* @param {Svchip_Cost_TelemetryInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_cost_telemetry = /** @type {((inputs?: Svchip_Cost_TelemetryInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Cost_TelemetryInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_cost_telemetry(inputs)
	if (locale === "bn") return bn_svchip_cost_telemetry(inputs)
	if (locale === "de") return de_svchip_cost_telemetry(inputs)
	if (locale === "es") return es_svchip_cost_telemetry(inputs)
	if (locale === "fr") return fr_svchip_cost_telemetry(inputs)
	if (locale === "pt") return pt_svchip_cost_telemetry(inputs)
	if (locale === "zh") return zh_svchip_cost_telemetry(inputs)
	if (locale === "tr") return tr_svchip_cost_telemetry(inputs)
	if (locale === "ru") return ru_svchip_cost_telemetry(inputs)
	if (locale === "pl") return pl_svchip_cost_telemetry(inputs)
	return en_svchip_cost_telemetry(inputs)
});